// src/store/modules/user.js
import { setToken, removeToken, setUserInfo } from '@/utils/auth'
import { login, logout } from '@/api/auth'
import { getUserInfo } from '@/api/user'
import { clearApiCache } from '@/utils/apiCache'
import { APP_NS } from '@/constants/appIdentity'
import {
    syncSupportAccessToken,
    clearSupportAccessToken,
} from '@/api/support'

export default {
    namespaced: true,
    state: {
        token: '',
        userInfo: null
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER_INFO(state, info) {
            state.userInfo = info
        }
    },
    actions: {
        // 修复 - 使用传入的loginForm参数而不是外部userInfo
        async login({ commit }, loginData) {
            const response = await login(loginData)
            clearApiCache()
            setToken(response.data.access)
            syncSupportAccessToken(response.data.access)
            commit('SET_TOKEN', response.data.access)
            return response
        },
        async getUserInfo({ commit }) {
            try {
                const response = await getUserInfo()
                setUserInfo(response.data)
                commit('SET_USER_INFO', response.data)
                return response
            } catch (error) {
                console.error('获取用户信息失败:', error)
                // 确保这里的错误处理不会导致无限循环
                if (error.response.status === 401) {
                    commit('SET_TOKEN', '')
                    commit('SET_USER_INFO', null)
                    removeToken()
                }
                return Promise.reject(error)
            }
        },
        // 退出登录
        logout({ commit }) {
            logout()
            return new Promise((resolve) => {
                clearSupportAccessToken()
                clearApiCache()
                commit('SET_TOKEN', '')
                commit('SET_USER_INFO', null)
                removeToken()
                // 只清本项目命名空间，避免误伤同域其它项目
                try {
                    const ns = `${APP_NS}:`
                    const lsKeys = []
                    for (let i = 0; i < localStorage.length; i += 1) {
                        const key = localStorage.key(i)
                        if (key && key.startsWith(ns)) lsKeys.push(key)
                    }
                    lsKeys.forEach((key) => localStorage.removeItem(key))

                    const ssKeys = []
                    for (let i = 0; i < sessionStorage.length; i += 1) {
                        const key = sessionStorage.key(i)
                        if (key && key.startsWith(ns)) ssKeys.push(key)
                    }
                    ssKeys.forEach((key) => sessionStorage.removeItem(key))
                } catch (e) {
                    // ignore
                }
                resolve()
            })
        }

    }
}